import {observable, action} from 'mobx'
import {json, get} from "../../../utils/ajax";
import {ValueObjToObj, formatParams, setStore, findChildren} from "../../../utils/Utils";
import {runInAction} from "mobx/lib/mobx";
import {message} from 'antd'
import moment from "moment";
import df from './views/images/df.png'
import yp from './views/images/yp.png'

class yjVehicleDepartmentsQueryStore {
    @observable loading
    @observable carService  //车系
    @observable overSeaCarService  //海外车系
    @observable announcement  //公告
    @observable index  //通知
    @observable obtainVin  //搜索时输入的value
    @observable initTableSelectData//初始化下拉数据
    @observable model
    @observable isShowPartDetail
    @observable partDetail //备件详情
    @observable formField
    @observable selectCar//选择的车系
    @observable formatMessage //国际化

    //备件目录
    @observable oneLevelMenu//一级目录的数据
    @observable twoLevelMenu//二级目录的数据
    @observable twoLeveLoading//二级目录加载数据
    @observable twoMenu//三级目录的数据
    @observable threeLeveLoading//三级目录的数据
    @observable photos//图片
    @observable result//四级目录的数据
    @observable resultLoading//四级目录加载数据
    @observable searchValue//搜索框的值
    @observable searchList//搜索出来的数据
    @observable searchLoading//搜索出来数据的加载
    @observable addHotList//前台热点回显
    @observable selectTwoMenu//选择的二级目录
    @observable selectThreeMenu//选择的三级目录
    @observable selectFourMenu//点击的四级目录
    @observable hotGrade//表格回显热点标号
    @observable selectMenu//点击零件定位
    @observable oneMenu//当前选择的一级目录
    @observable showTree//根据物料号查询多根树的模态框
    @observable treeRecord//点击的物料号
    @observable treeLoading//Loading
    @observable showSixPhotos//备件信息图片模态框
    @observable selectResult//选中右侧的表格项
    @observable showPhoto//显示大图的模态框
    @observable selectPhoto//当前显示的大图
    @observable showBreakPoint//断点模态框
    @observable breakPointDetail//断点信息
    @observable threeId//选择的三级目录id
    @observable replaceDetail//替换信息
    @observable showReplace //显示替换模态框
    @observable allHotList //所有热点列表，用来回显
    @observable threeLevelMenuClickRow //三级目录点击行的数据
    @observable rightUpperTableClickRow //四级目录点击行的数据
    @observable applicableModels //适用车型
    @observable twoTrackMainModel//查询二轨件详情模态框
    @observable twoTrackMainData//二轨件详情数据
    @observable editTwoTrackMainData//回显二轨件详情数据
    @observable twoTrackMainList//回显二轨件详情下拉列表
    @observable twoTrackDisplayModel//若果点击的字母不止一条数据，就会出现选择模态框
    @observable newsList//新闻弹框内容
    @observable newsVisible//新闻弹框显示属性
    @observable pictureHeight//中间内容的高度
    @observable leftHeight//左边内容的高度
    @observable rightHeight//右边内容的高度
    @observable showReplaceModal//备件详情
    @observable shoppingModel//购物车模块
    @observable shoppingRowData//点击行数据
    @observable editField
    @observable treeDatePagination
    @observable searchListModalVisible
    @observable level2Code   //主组号
    @observable level3Code   //分组号
    @observable vinCode    //Vin码
    @observable goToDis   //判断是否显示
    @observable vinSearchData //输入的Vin
    @observable judgeTheCar//判断车系
    @observable expandedLeftRowKeys//
    @observable sparePartNumberLoading//点击备件出来数据的加载
    @observable sparePartNumberModalVisible//控制点击右侧备件隐藏和显示
    @observable sparePartNumberList//存放备件详情信息

    @observable carMaterialNameObj//整车信息及生产日期
    @observable indexLoading//索引loading

    @observable news  //保存新闻显示
    @observable fontSizeStyle  //新闻显示字体大小
    @observable newsLoading  //新闻newsLoading

    constructor() {
        this.loading = false
        this.indexLoading = false
        this.carService = []
        this.overSeaCarService = []
        this.announcement = []
        this.index = []
        this.obtainVin = ''
        this.formField = {
            carYear: '',
            deploy: '',
            transmission: '',
            driveModel: '',
            displacement: '',
            emissionNormal: '',
            interiorColor: '',
        }
        this.initTableSelectData = {
            modelYearSet: [],
            powerSet: [],
            allocationSet: [],
            transTypeSet: [],
            driveTypeSet: [],
            displacementSet: [],
            interiorColorSet: [],
        }
        this.model = false
        this.isShowPartDetail = false
        this.partDetail = {}
        this.selectCar = {}
        this.formatMessage = () => {
        }

        //备件目录
        this.oneLevelMenu = []
        this.twoLevelMenu = []
        this.twoLeveLoading = false
        this.threeLeveLoading = false
        this.resultLoading = false
        this.searchLoading = false
        this.twoMenu = []
        this.photos = []
        this.result = []
        this.searchValue = ''
        this.searchList = []
        this.addHotList = []
        this.selectThreeMenu = ''
        this.selectFourMenu = ''
        this.selectMenu = ''
        this.oneMenu = ''
        this.selectTwoMenu = ''
        this.hotGrade = ''
        this.showTree = false
        this.treeRecord = {}
        this.treeLoading = false
        this.showSixPhotos = false
        this.selectResult = {}
        this.showPhoto = false
        this.selectPhoto = ''
        this.showBreakPoint = false
        this.breakPointDetail = []
        this.threeId = ''
        this.replaceDetail = []
        this.showReplace = false
        this.allHotList = []
        this.threeLevelMenuClickRow = {}
        this.rightUpperTableClickRow = {}
        this.applicableModels = []
        this.twoTrackMainModel = false
        this.twoTrackMainData = []
        this.editTwoTrackMainData = {}
        this.twoTrackMainList = []
        this.twoTrackDisplayModel = false
        this.newsList = []
        this.newsVisible = false
        this.pictureHeight = 0
        this.leftHeight = 0
        this.rightHeight = 0
        this.showReplaceModal = false
        this.shoppingModel = false
        this.shoppingRowData = {}
        this.editField = {}
        this.treeDatePagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.searchListModalVisible = false
        this.level2Code = ''
        this.level3Code = ''
        this.vinCode = ''
        this.goToDis = true
        this.vinSearchData = ''
        this.judgeTheCar = 1
        this.expandedLeftRowKeys = []
        this.sparePartNumberLoading = false
        this.sparePartNumberModalVisible = false
        this.sparePartNumberList = []
        this.brandType = []
        this.carBrandId = ''

        this.carMaterialNameObj={}

        this.news = {}
        this.fontSizeStyle='12px'
        this.newsLoading=false
    }

    /***新闻弹框**/
    @action
    newsModal = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/news/popupwindownews`)
        runInAction(() => {
            this.newsList = Array.isArray(res) ? res : []
            if (res && res.length > 0) {
                this.newsVisible = !sessionStorage.hideModal
                sessionStorage.hideModal = true;
            }

        })
    }

    /***车系页面初始化***/
    @action
    initCarService = async () => {
        this.loading = true
        // const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/checkLicensedAndPublishedBrandCarSeries?vin=${this.vinSearchData}&carBrandId=${this.carBrandId}`)
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/yijingVINQueryAuthorizationForBrandOrVehicleModel?vin=${this.vinSearchData}`)
        // const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseBrand/queryAllPublishedBrands`)
        runInAction(() => {
            this.carService = Array.isArray(res.EPCCarseriesCatalog) ? res.EPCCarseriesCatalog : []
            this.loading = false
        })
        return res;
    }

    /***海外车系页面初始化***/
    @action
    initOverSeaCarService = async () => {
        this.loading = true
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/queryOverseasModels?vin=${this.vinSearchData}`)
        runInAction(() => {
            this.overSeaCarService = Array.isArray(res) ? res : []
            this.loading = false
        })
        if (this.vinSearchData &&  (this.overSeaCarService.length === 0)) {
            message.warning(this.formatMessage({id: 'ConfigureQuery.PleaseCheckTheVinCodeInTheDomesticCarSeries'}))
        }
    }

    /**
     * 设置store对象，类似react的setStaterightHeight
     * @param obj
     */
    @action
    setStore = (obj) => {
        setStore(obj, this)
        if (Object.prototype.toString.call(obj) === '[object Object]') {
            for (let [key, value] of Object.entries(obj)) {
                this[key] = value
            }
        }
    }

    /***索引 index***/
    @action
    initIndex = async () => {
        this.indexLoading = true
        // const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/news/frontdesk`)
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/news/customizedFrontEndQueryForYijingIndex`)
        if (res && res.status === 0) {
            this.indexLoading = false
            return
        }
        runInAction(() => {
            this.index = res || []
            this.indexLoading = false
        })
    }
    // /***通知 announcement***/
    // @action
    // initAnnouncement = async() => {
    //     const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/news/frontdesk/announcement`)
    //     runInAction(() => {
    //         this.announcement=res.content || []
    //     })
    // }


    /**
     * 获取输入的vin
     * @param value
     */
    @action
    changeInputValue = (value) => {
        this.obtainVin = value
    }

    /**
     * 搜索
     * @returns {Promise<void>}
     */
    @action
    vinSearch = async (url) => {
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/isExistByVin?vin=${this.obtainVin}&carCode=${this.selectCar.carSeriesCode}`);
        runInAction(() => {
            if (res.status && res.data.isEnter) {
                window.open(`${url}/detail?carseriesName=${this.selectCar.carseriesName}&vin=${this.obtainVin}&data=${res.data.msg}`)
            } else {
                message.info(res.data.msg);
                if (res.data.config) {
                    let data = res.data.config.split('-')
                    this.formField = {
                        carYear: {value: data[0]},
                        displacement: {value: data[1]},
                        transmission: {value: data[2]},
                        emissionNormal: {value: data[3]},
                        driveModel: {value: data[4]},
                        deploy: {value: data[5]},
                    }
                }
            }
        })
    }

    /**
     * 重置
     */
    @action
    vinReset = () => {
        this.obtainVin = ''
    }

    /**
     * 点击小卡片显示模态框获取下拉数据
     * @param item
     * @param url
     * @returns {Promise<void>}
     */
    @action
    getSelectData = async (item, url) => {
        this.model = true
        this.selectCar = item
        this.search(url, item)
    }

    @action
    getSelectData1 = async (item, url) => {
        this.model = true
        this.selectCar = item
        this.search1(url, item)
    }

    /**
     * 获取模态框下拉数据
     * @returns {Promise<void>}
     */
    @action
    changeSelectData = async () => {
        let search = {}
        Object.keys(this.formField).forEach(key => {
            if (this.formField[key]) {
                search[`search.${key}`] = [this.formField[key].value]
            }
        })
        search[`search.carseriesCode`] = this.selectCar.carSeriesCode
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/getConfigOption`, search)
        runInAction(() => {
            this.initTableSelectData = {...this.initTableSelectData, ...res}
        })
    }

    /**
     * 关闭模态框
     */
    @action
    hideModal = () => {
        this.formField = {
            carYear: '',
            displacement: '',
            deploy: '',
            interiorColor: '',
            transmission: '',
            driveModel: '',
        }
        this.model = false
    }

    /**---------------------------------备件模态框组---------------------------------**/
    /**
     * 获取备件详情数据
     */
    @action
    getPartDetail = async (id, e, record) => {
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/getSparePartInfo/epcSparePartId/${id}`)
        runInAction(() => {
            let entryTimeEnd = !res.entryTimeEnd ? this.formatMessage({id: 'ConfigureQuery.Time'}) : moment(res.entryTimeEnd).format('YYYY-MM-DD')
            let entryTimeStart = !res.entryTimeStart ? this.formatMessage({id: 'ConfigureQuery.Time'}) : moment(res.entryTimeStart).format('YYYY-MM-DD')
            this.partDetail = res
            this.partDetail.time = `${entryTimeStart}---${entryTimeEnd}`
            this.isShowPartDetail = true
        })
    }

    @action
    onEditConfigFieldChange(changedFields) {
        this.formField = {...this.formField, ...changedFields}
    }

    /**
     * 选上级时清空下级
     * @param index
     */
    @action
    clearForm = (index) => {
        let list = Object.keys(this.initTableSelectData)
        list.forEach((item, i) => {
            if (i > index) {
                this.initTableSelectData[item] = {value: ''}
            }
        })
    }

    /**
     * 获取选择后下拉框数据
     */
    @action
    search = (url, item) => {
        let arr = url.split('/')
        let locale = arr[arr.length-2]
        let carseriesName =locale === 'zh' ? item.carseriesName : item.enCarseriesName
        window.open(`${url}/detail?carseriesCode=${item.carSeriesCode}&carseriesName=${carseriesName}&vin=${this.vinSearchData}`, '_blank')
    }

    /**
     * 获取选择后下拉框数据
     */
    @action
    search1 = (url, item) => {
        window.open(`${url}/detail?carseriesCode=${item.carSeriesCode}&carseriesName=${item.carseriesName}`, '_blank')
    }


    /**--------------------------------------------备件目录-------------------------------------------**/

    /**
     * 当vin存在时显示整车描述与生产日期
     */
    @action
    getCarMaterialName =async (a) => {
        const res =await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/saleserp/VINQueryVehicleDescription?vin=${a}`)
        this.carMaterialNameObj = res
    }


    /**
     * 初始化数据
     */
    @action
    initData = () => {
        this.twoMenu = []
        this.result = []
        this.searchList = []
        this.addHotList = []
        this.selectTwoMenu = ''
    }

    /**
     * 获取url中的参数并转化为对象
     * @param str
     */
    @action
    getUrlParmas(str) {
        let obj = {}
        str.substring(1).split('&').forEach(item => {
            const arr = item.split('=')
            obj[arr[0]] = decodeURI(arr[1])
        })
        return obj
    }

    /**
     *获取一级目录的数据
     */
    @action
    catalogueIData = async () => {
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        let obj = {}
        if (paramsObj.data) {
            obj = {
                carYear: '',
                displacement: '',
                transmission: '',
                emissionNormal: '',
                driveModel: '',
                deploy: '',
                vin: '',
            }
        } else {
            obj = {...paramsObj}
        }
        paramsObj.vin && this.getCarMaterialName(paramsObj.vin)
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/queryNineCategories`, formatParams(obj))
        runInAction(() => {
            this.oneLevelMenu = Array.isArray(res) ? res : []
            //获取二级目录
            if(paramsObj.code){
                let codes=paramsObj.code
                const code = codes.match(/-(.+)/)[1];
                let firstChar = code[0]
                const id = this.oneLevelMenu[firstChar-1].id
                const path = `/${firstChar}`
                this.selectOneMenuData(path, id, firstChar)
            }else{
                const id = this.oneLevelMenu[0] ? this.oneLevelMenu[0].id : ''
                const path = this.oneLevelMenu[0] ? this.oneLevelMenu[0].path : ''
                const code = this.oneLevelMenu[0] ? this.oneLevelMenu[0].code : ''
                this.selectOneMenuData(path, id, code)
            }
        })
    }

    /**
     * 通过点击一级目录获取二级目录的数据
     * @param path
     * @param id
     * @param code
     * @returns {Promise<void>}
     */
    @action
    selectOneMenuData = async (path, id, code) => {
        this.twoMenu = []
        this.result = []
        this.addHotList = []
        this.selectTwoMenu = ''
        this.selectThreeMenu = ''
        this.selectFourMenu = ''
        this.hotGrade = ''
        this.rightUpperTableClickRow = {}
        this.threeLevelMenuClickRow = {}
        this.twoLeveLoading = true
        this.oneMenu = path
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        let data = {}
        if (paramsObj.data) {
            data = {
                carYear: '',
                displacement: '',
                transmission: '',
                emissionNormal: '',
                driveModel: '',
                deploy: '',
                vin: '',
            }
        } else {
            data = {...paramsObj}
        }
        let nineId = id
        if (!nineId) {
            for (let item of this.oneLevelMenu) {
                if (item.path === path) {
                    nineId = item.id
                    break
                }
            }
        }
        let obj = {
            [`search.carseriesCode`]: this.oneLevelMenu[0] ? this.oneLevelMenu[0].carseriesCode : '',
            [`search.nineId`]: nineId,
            [`search.nineCode`]: code !== undefined ? code : this.oneLevelMenu[0].code,
            ...formatParams(data)
        }
        // const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/queryTwoCatalogsByNineCategorieI`, obj)
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/vehicleSeriesVINQueryMainQroup`, obj)
        await this.getPhotoList(nineId, code, paramsObj)
        runInAction(() => {
            this.twoLevelMenu = Array.isArray(res) ? res : []
            this.twoLeveLoading = false
        })
        //     获取车系及分组号时逻辑处理  ex：H30 120-10
        if(paramsObj.code){
            this.getCodeToDetail(paramsObj.code)
        }
    }

    /**
     * 二级目录的点击事件
     * @param record
     * @param index
     */
    @action
    twoLevelMenuClick = async (record, index) => {
        this.selectTwoMenu = record.path
        this.addHotList = []
        this.result = []
        this.hotGrade = ''
        this.goToDis = true
        this.selectFourMenu = ''
        this.rightUpperTableClickRow = {}
        this.threeLevelMenuClickRow = {}
        this.level2Code = record.code
        await this.getThreeLevelMenu(record)
    }

    /**
     * 通过点击二级目录获取三级目录的数据
     * @param record
     */
    @action
    getThreeLevelMenu = async (record) => {
        this.threeLeveLoading = true
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        const toConfigure = decodeURI(paramsObj.data).split('-')
        let obj = {}
        if (paramsObj.data) {
            obj = {
                carYear: toConfigure[0],
                displacement: toConfigure[1],
                transmission: toConfigure[2],
                emissionNormal: toConfigure[3],
                driveModel: toConfigure[4],
                deploy: toConfigure[5],
                vin: decodeURI(paramsObj.vin),
                carseriesCode: this.oneLevelMenu[0] ? this.oneLevelMenu[0].carseriesCode : '',
                twoCatalohId: record.id,
                twoCatalohCode: record.code
            }
        } else {
            obj = {
                ...paramsObj,
                carseriesCode: this.oneLevelMenu[0] ? this.oneLevelMenu[0].carseriesCode : '',
                twoCatalohId: record.id,
                twoCatalohCode: record.code
            }
        }

        // const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/queryThreeCatalogsByTwoCategorieId`, formatParams(obj))
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/vehicleSeriesVINLookupQroup`, formatParams(obj))
        runInAction(() => {
            this.twoMenu = Array.isArray(res) ? res : []
            this.threeLeveLoading = false
            this.photos = this.twoMenu.length > 0 && this.twoMenu
            this.selectThreeMenu = this.twoMenu.length > 0 && this.twoMenu.length <= 1 && this.photos[0].path
            this.twoMenu.length > 0 && this.twoMenu.length <= 1 && this.threeLevelMenuClick(this.photos[0])
        })
    }

    /**
     * 图片数据
     * @param id
     * @param code
     * @param paramsObj
     * @returns {Promise<void>}
     */
    @action
    getPhotoList = async (id, code, paramsObj) => {
        const search = window.location.search
        const paramsObj1 = this.getUrlParmas(search)
        let condition = paramsObj || paramsObj1
        const obj = {
            carseriesCode: this.oneLevelMenu[0] ? this.oneLevelMenu[0].carseriesCode : '',
            nineId: id,
            nineCode: code !== undefined ? code : this.oneLevelMenu[0].code,
            ...condition,
        }
        // const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/queryPhotos`, formatParams(obj))
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/vehicleSeriesVINQueryQroupPictures`, formatParams(obj))
        runInAction(() => {
            this.photos = Array.isArray(res) ? res : []
        })
    }

    /**
     * 点击图片时定位到二级目录上
     * @param item
     */
    @action
    twoLocation = (item) => {
        const arr = item.figureNo.split('-');
        const firstChar = arr[1][0];
        const parentStr = arr.slice(0, 2).join('-');
        const result = `/${firstChar}/${parentStr}`;

        let record = {}
        let index = 0
        this.twoLevelMenu.find((v, i) => {    //用find只是可以提前打断遍历
            this.expandedLeftRowKeys = [v.path]
            const same = v.path === result
            if (same) {
                record = v
                index = i
            }
            return same
        })
        this.twoLevelMenuClick(record, index)
    }

    /**
     * 三级目录的点击事件
     * @param record
     */
    @action
    threeLevelMenuClick = async (record) => {
        this.rightUpperTableClickRow = {}
        this.threeLevelMenuClickRow = record
        this.addHotList = []
        this.hotGrade = ''
        this.goToDis = false
        this.selectThreeMenu = record.path
        this.resultLoading = true
        this.threeId = record.id
        this.photos = [record.imgUrl || '']
        this.level3Code = record.code
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        const toConfigure = decodeURI(paramsObj.data).split('-')
        let data = {}
        if (paramsObj.data) {
            data = {
                carYear: toConfigure[0],
                displacement: toConfigure[1],
                transmission: toConfigure[2],
                emissionNormal: toConfigure[3],
                driveModel: toConfigure[4],
                deploy: toConfigure[5],
                vin: decodeURI(paramsObj.vin),
            }
        } else {
            data = {...paramsObj}
        }
        // const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/querySparePartsByThreeCategorieId`, {
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/checkTheVehicleSeriesVINForSpareParts`, {
            [`search.threeCatalohId`]: record.id,
            [`search.carseriesCode`]: record.carseriesCode,
            ...formatParams(data)
        })
        runInAction(() => {
            this.result = Array.isArray(res) ? res : []
            this.resultLoading = false
            this.allHotList = this.result.reduce((acc, cur) => {
                let list = Array.isArray(cur.coordinateList) ? cur.coordinateList.map(item => {
                    return {...item, grade: cur.grade}
                }) : []
                return acc.concat(list)
            }, [])
        })
    }

    /**
     * 获取到input输入的值
     * @param value
     */
    @action
    searchValueClickData = (value) => {
        this.searchValue = value
    }

    /**
     * 查询
     */
    @action
    searchValueData = async () => {
        if (!this.searchValue) {
            message.warning(this.formatMessage({id: 'ConfigureQuery.PleaseEnterTheSearchCriteria'}))
            return
        }
        this.searchLoading = true
        this.searchListModalVisible = true
        this.sparePartNumberModalVisible = false
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        const toConfigure = decodeURI(paramsObj.data).split('-')
        let data = {}
        if (paramsObj.data) {
            data = {
                carYear: toConfigure[0],
                displacement: toConfigure[1],
                transmission: toConfigure[2],
                emissionNormal: toConfigure[3],
                driveModel: toConfigure[4],
                deploy: toConfigure[5],
                vin: decodeURI(paramsObj.vin),
            }
        } else {
            data = {...paramsObj}
        }
        let obj = {content: this.searchValue, ...data}
        if (paramsObj.carseriesId) {
            obj.carseries = paramsObj.carseriesId
        }
        // const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/querySparePartsByContent`, formatParams(obj))
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/frontDeskInquiry`, formatParams(obj))
        runInAction(() => {
            this.searchList = Array.isArray(res) ? res : []
            this.searchLoading = false
        })
    }

    /**点击备件查询详情**/
    @action
    sparePartNumber = async (record) => {
        this.sparePartNumberLoading = true
        this.sparePartNumberModalVisible = true
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        // const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/verification/queryDetailedInformationBasedOnSpareParts/carseriesCode`, {
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/verification/checkTheDetailedInformationOfTheSparePartNumber`, {
            [`search.lv3Id`]: record.catalogId,
            [`search.carseriesCode`]: paramsObj.carseriesCode,
            [`search.vin`]: paramsObj.vin,
            [`search.grade`]: record.grade
        })
        runInAction(() => {
            this.sparePartNumberList = Array.isArray(res) ? res : []
            this.sparePartNumberLoading = false
        })
    }

    /**
     * 右下表格的点击事件
     * @param record
     */
    @action
    rightUpperTableClick = async (record) => {
        this.threeLevelMenuClickRow = {}
        this.rightUpperTableClickRow = record
        this.addHotList = record && record.coordinateList
        this.selectFourMenu = record.id
        this.hotGrade = ''
        this.searchListModalVisible = false
    }

    /**
     * 热点定位
     * @param hot
     */
    @action
    editPosHot = (hot) => {
        this.addHotList = [hot]
        this.selectFourMenu = ''
        this.hotGrade = hot.grade
    }

    /**
     * 点击零件定位到指定的目录去
     * @param record
     * @returns {Promise<void>}
     */
    @action
    locationData = async (record) => {
        this.selectMenu = record.spareNo
        const paths = record.path.split('/')
        const oneMenu = `/${paths[1]}`
        const twoMenu = `${oneMenu}/${paths[2]}`
        const threeMenu = record.path
        const code1 = `${paths[1]}`
        // const code2 = `${paths[2]}`
        const code3 = `${paths[3]}`
        if (threeMenu === this.selectThreeMenu) {
            //如果当前就是要定位的三级目录则return
            this.queryTheFirstLevelCatalogAccordingToTheCarCodeAndCatalogCode(record.carseriesCode, code1)
            await this.queryTheFirstLevelCatalogAccordingToTheCarCodeAndCatalogCode3ji(record.carseriesCode, code3)
            // await this.changeExpandedLeftRowKeys(threeMenu)
            await this.changeExpandedLeftRowKeys2(record)
            this.expandedLeftRowKeys = [twoMenu, threeMenu]
            this.addHotList = record && record.coordinateList
            return
        }
        //定位一级目录、获取二级目录
        if (oneMenu !== this.oneMenu) {
            await this.selectOneMenuData(oneMenu)
        }
        // 定位二级目录
        let obj = {}
        let index = -1
        this.twoLevelMenu.find((item, i) => {
            if (item.path === twoMenu) {
                obj = item
                index = i
            }
            return item.path === twoMenu    //这里只是在找到后打断遍历提高效率
        })
        if (index === -1) {
            return
        }
        if (this.selectTwoMenu[0] !== twoMenu) {
            await this.twoLevelMenuClick(obj, index)
        }
        //定位三级目录this.twoMenu
        const item = this.twoMenu.find(i => i.path === record.path)
        await this.threeLevelMenuClick(item)
        let data = this.result.find(item => item.id === record.id)
        await this.rightUpperTableClick(data)
    }

    /**
     * 查询多根树
     * @param record
     * @returns {Promise<void>}
     */
    @action
    getTree = async (record, e) => {
        this.showTree = true
        this.treeRecord = record
        this.treeLoading = true
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/getFrontPurchaseStatus/${record.materialNo}`, {size: this.treeDatePagination.pageSize})
        runInAction(() => {
            this.treeLoading = false
            this.treeDate = res.content ? findChildren(res.content) : []
        })
    }

    @action
    changedField = (changedFields) => {
        this.editField = {...this.editField, ...ValueObjToObj(changedFields)}
    }

    /**
     * 点击购物车
     */
    @action
    clickShoppingData = async (record) => {
        this.shoppingModel = true
        this.shoppingRowData = record
    }

    /**
     * 添加购物车
     *
     * @returns {Promise<void>}
     */
    @action
    addShoppingData = async () => {
        this.shoppingModel = false
        let data = {
            serviceCodeList: [],
            materialNo: this.shoppingRowData.materialNo ? this.shoppingRowData.materialNo : '',
            spareName: this.shoppingRowData.spareName ? this.shoppingRowData.spareName : '',
            spareNo: this.shoppingRowData.spareNo ? this.shoppingRowData.spareNo : '',
            orderNumber: this.editField.orderNumber
        }
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/shoppingCar/addToShoppingCar`, data)
        if (res.status) {
            message.success(this.formatMessage({id: 'ConfigureQuery.success'}))
        } else {
            message.warning(this.formatMessage({id: 'ConfigureQuery.warning'}))
        }
        runInAction(() => {
            this.editField = {}
        })
    }

    /**
     * 查询图片信息
     * @param record
     * @param e
     */
    @action
    getPhotoData = async (record, e) => {
        this.showSixPhotos = true
        this.selectResult = record
    }

    /**
     * 查询断点信息
     * @param record
     * @param e
     * @returns {Promise<void>}
     */
    @action
    getBreakPointData = async (record, e) => {
        this.showBreakPoint = true
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/getBreakPointInfoByMaterialNo/${record.materialNo}`)
        runInAction(() => {
            this.breakPointDetail = Array.isArray(res) ? res : []
        })
    }

    /**
     * 查询替换信息
     * @param record
     * @param e
     * @returns {Promise<void>}
     */
    @action
    editGetReplaceInfo = async (record, e) => {
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        const obj = {
            [`search.bySpareNo`]: record.spareNo,
            [`search.carseriesCode`]: paramsObj.carseriesCode,
            [`search.catalogId`]: this.threeId
        }
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/getChangeInfoByMaterialNo`, obj)
        runInAction(() => {
            this.replaceDetail = Array.isArray(res) ? res : []
            this.showReplace = true
        })
    }

    /**
     * 查询二轨件详情
     * @param record
     * @param letter
     */
    @action
    EditTwoTrackDisplay = async (record, letter) => {
        let search = {};
        search[`search.catalogSparePartId`] = record.id;
        search[`search.trackLetter`] = letter;
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/twoTrack/getTwoTrackInfoList:search`, search);
        runInAction(() => {
            this.twoTrackMainList = Array.isArray(res) ? res : []
            if (this.twoTrackMainList.length > 1) {
                this.twoTrackDisplayModel = true
            } else {
                this.editMultiTrackParts(record, 0)
            }
        })
    }

    /**
     * 显示模态框
     *
     */
    @action
    editMultiTrackParts = (record, index) => {
        this.twoTrackDisplayModel = false
        this.twoTrackMainModel = true
        let list = this.twoTrackMainList[index].list || []
        let arr = []
        let name = [this.formatMessage({id: 'ConfigureQuery.TwoTrackFittings'}), this.formatMessage({id: 'ConfigureQuery.ThreeTrackFittings'}),
            this.formatMessage({id: 'ConfigureQuery.FourTrackFittings'}), this.formatMessage({id: 'ConfigureQuery.FiveTrackFittings'}),
            this.formatMessage({id: 'ConfigureQuery.SixTrackFittings'}), this.formatMessage({id: 'ConfigureQuery.SevenTrackFittings'}),
            this.formatMessage({id: 'ConfigureQuery.EightTrackFittings'}), this.formatMessage({id: 'ConfigureQuery.NineTrackFittings'})]
        for (let i = 0; i < list.length; i++) {
            arr.push({
                railFittings: name[i],
                manyTrackName: `manyTrackName${i}`,
                manyTrackNo: `manyTrackNo${i}`,
                manyTrackSupplier: `manyTrackSupplier${i}`,
                manyTrackSupplierNo: `manyTrackSupplierNo${i}`
            })
        }
        this.twoTrackMainData = arr

        let arr2 = []
        for (let i = 0; i < list.length; i++) {
            arr2.push({
                [`manyTrackName${i}`]: list[i].manyTrackName,
                [`manyTrackNo${i}`]: list[i].manyTrackNo,
                [`manyTrackSupplier${i}`]: list[i].manyTrackSupplier,
                [`manyTrackSupplierNo${i}`]: list[i].manyTrackSupplierNo
            })
            this.editTwoTrackMainData = {...this.editTwoTrackMainData, ...arr2[i], ...this.twoTrackMainList[index]}
        }
    }

    /**
     * 展开的行变化时触发
     * @param expandedRows
     */
    @action
    changeExpandedLeftRowKeys = (expandedRows) => {
        this.expandedLeftRowKeys = expandedRows
        // this.searchListModalVisible = false
    }

    /**
     * 展开的行变化时触发
     * @param expandedRows
     */
    @action
    changeExpandedLeftRowKeys2 = (record) => {
        this.selectFourMenu = record.id
        // this.addHotList = record && record.coordinateList
    }

    /**
     * 根据车系code和目录code查询1级目录
     * @param record
     */
    @action
    queryTheFirstLevelCatalogAccordingToTheCarCodeAndCatalogCode = async (carseriesCode, code) => {
        this.loading = true
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalog/queryTheFirstLevelCatalogAccordingToTheCarCodeAndCatalogCode2?carCode=${carseriesCode}&code=${code}`)
        runInAction(() => {
            this.loading = false
            this.selectOneMenuData2(res.path, res.id, res.code)
        })
    }

    /**
     * 根据车系code和目录code查询2级目录
     * @param record
     */
    @action
    queryTheFirstLevelCatalogAccordingToTheCarCodeAndCatalogCode2ji = async (carseriesCode, code) => {
        this.loading = true
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalog/queryTheFirstLevelCatalogAccordingToTheCarCodeAndCatalogCode2?carCode=${carseriesCode}&code=${code}`)
        runInAction(() => {
            this.loading = false
            this.getThreeLevelMenu(res)
        })
    }

    /**
     * 根据车系code和目录code查询3级目录
     * @param record
     */
    @action
    queryTheFirstLevelCatalogAccordingToTheCarCodeAndCatalogCode3ji = async (carseriesCode, code) => {
        this.loading = true
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalog/queryTheFirstLevelCatalogAccordingToTheCarCodeAndCatalogCode?carCode=${carseriesCode}&code=${code}`)
        runInAction(() => {
            this.loading = false
            this.threeLevelMenuClick(res)
        })
    }

    /**
     * 点击右下列表触发三级目录的点击事件
     * @param record
     */
    @action
    threeLevelMenuClick2 = async (record) => {
        this.rightUpperTableClickRow = {}
        this.threeLevelMenuClickRow = record
        this.addHotList = []
        this.hotGrade = ''
        this.goToDis = false
        this.selectThreeMenu = record.path
        this.resultLoading = true
        this.threeId = record.catalogId
        this.photos = [record.imgUrl || '']
        this.level3Code = record.code
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        const toConfigure = decodeURI(paramsObj.data).split('-')
        let data = {}
        if (paramsObj.data) {
            data = {
                carYear: toConfigure[0],
                displacement: toConfigure[1],
                transmission: toConfigure[2],
                emissionNormal: toConfigure[3],
                driveModel: toConfigure[4],
                deploy: toConfigure[5],
                vin: decodeURI(paramsObj.vin),
            }
        } else {
            data = {...paramsObj}
        }
        // const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/querySparePartsByThreeCategorieId`, {
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/checkTheVehicleSeriesVINForSpareParts`, {
            [`search.threeCatalohId`]: record.catalogId,
            [`search.carseriesCode`]: record.carseriesCode,
            ...formatParams(data)
        })
        runInAction(() => {
            this.result = Array.isArray(res) ? res : []
            this.resultLoading = false
            this.allHotList = this.result.reduce((acc, cur) => {
                let list = Array.isArray(cur.coordinateList) ? cur.coordinateList.map(item => {
                    return {...item, grade: cur.grade}
                }) : []
                return acc.concat(list)
            }, [])
        })
    }

    /**
     * 通过点击一级目录获取二级目录的数据
     * @param path
     * @param id
     * @param code
     * @returns {Promise<void>}
     */
    @action
    selectOneMenuData2 = async (path, id, code) => {
        this.twoMenu = []
        this.result = []
        this.addHotList = []
        this.selectTwoMenu = ''
        this.hotGrade = ''
        this.rightUpperTableClickRow = {}
        this.threeLevelMenuClickRow = {}
        this.twoLeveLoading = true
        this.oneMenu = path
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        let data = {}
        if (paramsObj.data) {
            data = {
                carYear: '',
                displacement: '',
                transmission: '',
                emissionNormal: '',
                driveModel: '',
                deploy: '',
                vin: '',
            }
        } else {
            data = {...paramsObj}
        }
        let nineId = id
        if (!nineId) {
            for (let item of this.oneLevelMenu) {
                if (item.path === path) {
                    nineId = item.id
                    break
                }
            }
        }
        let obj = {
            [`search.carseriesCode`]: this.oneLevelMenu[0] ? this.oneLevelMenu[0].carseriesCode : '',
            [`search.nineId`]: nineId,
            [`search.nineCode`]: code !== undefined ? code : this.oneLevelMenu[0].code,
            ...formatParams(data)
        }
        // const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/queryTwoCatalogsByNineCategorieI`, obj)
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/vehicleSeriesVINQueryMainQroup`, obj)
        runInAction(() => {
            this.twoLevelMenu = Array.isArray(res) ? res : []
            this.twoLeveLoading = false
        })
    }

    /**
     * 点击下面的表格
     * @param record
     */
    @action
    clickTheTableBelow = async (record) => {
        this.selectFourMenu = record.id
    }

    /**
     * 通过备件车系分组号跳转
     * @param path
     * @param id
     * @param code
     * @returns {Promise<void>}
     */
    @action
    getCodeToDetail = async (code) => {
        const result = this.twoLevelMenu
            .flatMap(item => item.children || []) // 关键修复：空值转空数组
            .find(child => child.code === code);
        if (result) {
            const parts = code.split('-');
            const p = parts.slice(0,2).join('-');
            const n = parts[1][0];
            this.expandedLeftRowKeys = [`/${n}/${p}`, `/${n}/${p}/${code}`];
            this.threeLevelMenuClick(result)
        }
    }



    /***保存当前新闻内容***/
    @action
    initNews = async (name, id) => {
        this.newsLoading=true
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/news/customizedFrontEndQueryForYijingIndex`)
        let res1 = res && res.filter(item => item.id === id)
        runInAction(()=>{
            this.news=res1[0]
            this.newsLoading=false
        })
    }


    /***保存当前新闻内容***/
    @action
    hrefDms = async () => {
        this.newsLoading=true
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/dmsJumpingGuide/goToTheYijingManual`)
        runInAction(()=>{
            console.log(res,typeof res)
            window.open(res.data, '_blank');
        })


    }


}

export default new yjVehicleDepartmentsQueryStore()



// WEBPACK FOOTER //
// ./src/project/yijing/VehicleDepartmentsQuery/store.js